import { useEffect, useContext, useRef, useState } from "react";
import GlobalStyles from "./Globalstyle";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import { gsap } from "gsap/gsap-core";
import { useGSAP } from "@gsap/react";
import { PortfolioContext } from "./AppContext";
import styled from "styled-components";
import { ReactLenis } from "lenis/react";

const App = () => {
	const {
		enterHero,
		mousePosition,
		setMousePosition,
		enterAboutMe,
		enterProjects,
		enterFooter,
		cursorLabel,
	} = useContext(PortfolioContext);
	const [isMobile, setIsMobile] = useState(false);

	// const lenisRef = useRef();

	// useEffect(() => {
	// 	function update(time) {
	// 		lenisRef.current?.lenis?.raf(time * 1000);
	// 	}

	// 	gsap.ticker.add(update);

	// 	return () => gsap.ticker.remove(update);
	// }, []);

	useGSAP(() => {
		setIsMobile(window.innerWidth <= 768);
		const cursorStyle = {
			x: mousePosition.x,
			y: mousePosition.y,
			height: "20px",
			width: "20px",
			borderRadius: "50%",
			position: "fixed",
			pointerEvents: "none",
			zIndex: "9999",
			transition: "background-color 0.2s ease",
		};
		if (enterHero || (enterProjects && !isMobile)) {
			gsap.set(".cursor", {
				...cursorStyle,
				backgroundColor: "#3b0000",
			});
		} else if (enterAboutMe || (enterFooter && !isMobile)) {
			gsap.set(".cursor", {
				...cursorStyle,
				backgroundColor: "#f5ebe0",
			});
		} else {
			gsap.to(".cursor", {
				x: mousePosition.x,
				y: mousePosition.y,
				...cursorStyle,
				duration: 0.5,
				ease: "none",
			});
		}
	}, [mousePosition]);

	useEffect(() => {
		const mouseMove = (e) => {
			setMousePosition({
				x: e.clientX,
				y: e.clientY,
			});
		};

		window.addEventListener("mousemove", mouseMove);
		window.addEventListener("keydown", mouseMove);
	}, []);

	return (
		<>
			<CursorContainer className="cursor">
				{cursorLabel && <span className="cursor-label">{cursorLabel}</span>}
			</CursorContainer>
			{/* <ReactLenis root options={{ autoRaf: false }} ref={lenisRef} /> */}
			<BrowserRouter>
				<GlobalStyles />
				<Routes>
					<Route path="/" element={<Home />} />
				</Routes>
			</BrowserRouter>
		</>
	);
};

export default App;

const CursorContainer = styled.div`
	.cursor-label {
		position: absolute;
		top: -30px;
		left: 20px;
		font-size: 12px;
		background: rgba(0, 0, 0, 0.6);
		color: white;
		padding: 4px 8px;
		border-radius: 4px;
		font-family: sans-serif;
		pointer-events: none;
		white-space: nowrap;
		z-index: 999;
	}
`;
